/**
 * @generated SignedSource<<c6e4f3c4d9a31732c56f7cd1bbd94d34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPurchaseButton_viewer$data = {
  readonly showAddToCartButton: boolean | null;
  readonly " $fragmentType": "PdpSharedPurchaseButton_viewer";
};
export type PdpSharedPurchaseButton_viewer$key = {
  readonly " $data"?: PdpSharedPurchaseButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPurchaseButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPurchaseButton_viewer",
  "selections": [
    {
      "alias": "showAddToCartButton",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCartAddToCartButton"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCartAddToCartButton\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f3928bfbcd031bc73cfabfb29cd2dd84";

export default node;
